import { createFileRoute, Navigate } from '@tanstack/react-router';
import { PROFILE_VIEW } from '../../station/nav.js';
import { useStation } from '../../station/station.js';

// The station opens on the view its profile is for (set per station in the Admin).
function StartView() {
  const station = useStation();
  return <Navigate to={PROFILE_VIEW[station?.profile ?? 'production']} replace />;
}

export const Route = createFileRoute('/_station/')({
  component: StartView,
});
